export default __webpack_public_path__ + "static/megaVirtualc-ef53432f92021a971f2448ad0d58fb72.jpg";